import { frontendURL } from '../../../helper/URLHelper';
import OrderActionsView from './OrderActionsView.vue';
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/order-actions'),
      name: 'order_actions_dashboard',
      meta: { permissions: ['administrator'] },
      component: OrderActionsView,
    },
  ],
};
